'use client';

import dynamic from 'next/dynamic';

export const HeartbeatBeacon = dynamic(
  () => import('./heartbeat-beacon'),
  { ssr: false },
);
